export interface IframeParams {
  token?: string;
  currency?: string;
  locale?: string;
  theme?: 'light' | 'dark';
  location?: string;
  oddsFormat?: string;
}

export function parseIframeParams(): IframeParams {
  const params = new URLSearchParams(window.location.search);
  const locationParam = params.get('location');

  const iframeParams: IframeParams = {
    token: params.get('token') || undefined,
    currency: params.get('currency') || undefined,
    locale: params.get('locale') || undefined,
    theme: (params.get('theme') as 'light' | 'dark') || undefined,
    location: locationParam || undefined,
    oddsFormat: params.get('oddsFormat') || undefined,
  };

  return iframeParams;
}
